import React from "react";
import { MapPin, Phone, Mail, MessageCircle, ShieldCheck, Sparkles, Instagram } from "lucide-react";
import { clinic, navLinks } from "../mock";

export default function Footer() {
  const handleNav = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="section-navy text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="inline-flex bg-white rounded-2xl px-4 py-3 shadow-lg">
              <img
                src={clinic.logoSantaLucia}
                alt="Centro Oftalmológico Santa Lucía"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-blue-100/60 mt-5 max-w-sm leading-relaxed">
              Centro oftalmológico especializado en Retina, Cataratas y Glaucoma en
              {" "}{clinic.city}, {clinic.region}. Tu visión es nuestra prioridad.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={clinic.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full grid place-items-center bg-white/10 border border-white/15 hover:bg-white/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={clinic.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full grid place-items-center bg-white/10 border border-white/15 hover:bg-white/20 transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
              <a
                href={`tel:${clinic.callCenterTel}`}
                className="w-10 h-10 rounded-full grid place-items-center bg-white/10 border border-white/15 hover:bg-white/20 transition-colors"
                aria-label="Teléfono"
              >
                <Phone size={18} />
              </a>
              <a
                href={`mailto:${clinic.email}`}
                className="w-10 h-10 rounded-full grid place-items-center bg-white/10 border border-white/15 hover:bg-white/20 transition-colors"
                aria-label="Correo"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div>
            <div className="font-display font-bold text-sm uppercase tracking-wide text-blue-200">
              Navegación
            </div>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => handleNav(l.href)}
                    className="text-sm text-blue-100/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={clinic.luciaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-blue-100/70 hover:text-white transition-colors"
                >
                  <Sparkles size={14} /> Asistente LucIA
                </a>
              </li>
              <li>
                <a
                  href={clinic.panelUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-blue-100/70 hover:text-white transition-colors"
                >
                  <ShieldCheck size={14} /> Panel Clínico
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-display font-bold text-sm uppercase tracking-wide text-blue-200">
              Contacto
            </div>
            <ul className="mt-4 space-y-3 text-sm text-blue-100/70">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" /> {clinic.address}
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} /> {clinic.callCenter}
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} /> {clinic.email}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-blue-100/50">
          <span>© {new Date().getFullYear()} Centro Oftalmológico Santa Lucía. Todos los derechos reservados.</span>
          <div className="flex items-center gap-4">
            <a href={clinic.luciaUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              Política de Privacidad · App LucIA
            </a>
            <span>Protegido bajo Ley 19.628 · Chile</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
